export function isTouchDevice() {
    // https://stackoverflow.com/a/4819886/3717467
    return (('ontouchstart' in window) ||
        (navigator.maxTouchPoints > 0) ||
        (navigator.msMaxTouchPoints > 0));
}

const EXT_PATHS = {
    'lfmsite': 'c1dda3cd8b878b3d2d1341386e1ea699',
    //'lfmcore': 'd82109b30f039cce2bbf4e00dddffabc',
    //'lfmdsgvo':'c7f7dac81748f8386e8398e24852227e',
};

export function asset(path) {
    let match = path.match(/^EXT:([^\/]+)\/Resources\/Public\/(.*?)$/);
    if (match) {
        let extKey = match[1];
        if (!EXT_PATHS.hasOwnProperty(extKey)) {
            throw new Error(`Unknown extension key "${extKey}" in asset path "${path}". Extend EXT_PATHS in Utils.js accordingly.`);
        }
        let hash = EXT_PATHS[extKey];
        return `/_assets/${hash}/${match[2]}`;
    }
    return path;
}

/**
 * @param url {URL|string}
 * @param params
 * @returns {Promise<unknown>}
 */
export function loadJs(url, params) {
    return new Promise((resolve, reject) => {
        if (url instanceof URL) {
            url = url.toString();
        }
        const script = document.createElement('script');
        script.onload = () => resolve(script);
        script.onerror = () => reject(new Error(`Failed to load script ${url}`));
        if (params) {
            Object.keys(params).forEach(key => {
                script.setAttribute(key, params[key]);
            });
        }
        script.src = url;
        document.head.appendChild(script);
    });
}

